export class LRUMap<K, V> extends Map<K, V> {
  private maxSize: number

  constructor(maxSize: number) {
    super()
    this.maxSize = maxSize
  }

  set(key: K, value: V): this {
    if (this.has(key)) {
      this.delete(key)
    } else if (this.size >= this.maxSize) {
      const firstKey = this.keys().next().value
      this.delete(firstKey)
    }
    super.set(key, value)
    return this
  }
}
